if (!customElements.get('yds-free-shipping-progress')) {
  customElements.define(
    'yds-free-shipping-progress',
    class YdsFreeShippingProgress extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) || 5000;
        this.currency = this.dataset.currency || 'USD';
        this.messageBefore = this.dataset.messageBefore || "You're [amount] away from free U.S. shipping.";
        this.messageSuccess = this.dataset.messageSuccess || "You've unlocked free U.S. shipping!";
        this.messageElement = this.querySelector('[data-shipping-progress-message]');
        this.trackElement = this.querySelector('[data-shipping-progress-track]');
        this.fillElement = this.querySelector('[data-shipping-progress-fill]');
        this.handlePageShow = () => this.refresh();
        this.update(Number(this.dataset.cartTotal) || 0);
        this.refresh();
        window.addEventListener('pageshow', this.handlePageShow);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        window.removeEventListener('pageshow', this.handlePageShow);
      }

      async refresh() {
        try {
          const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;
          const cart = await response.json();
          this.update(Number(cart.total_price) || 0);
        } catch (error) {
          return;
        }
      }

      update(total) {
        const remaining = Math.max(this.threshold - total, 0);
        const percentage = Math.min(Math.max((total / this.threshold) * 100, 0), 100);
        const complete = remaining === 0;
        const message = complete
          ? this.messageSuccess
          : this.messageBefore.replace('[amount]', this.formatMoney(remaining));

        this.classList.toggle('is-complete', complete);
        this.dataset.cartTotal = String(total);
        if (this.messageElement) this.messageElement.textContent = message;
        if (this.fillElement) this.fillElement.style.width = `${percentage}%`;
        if (this.trackElement) {
          this.trackElement.setAttribute('aria-valuenow', String(Math.round(percentage)));
          this.trackElement.setAttribute('aria-valuetext', message);
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(2)}`;
        }
      }
    }
  );
}
